<template>
  <div class="footer-flex-container">
    <div class="footer-left-spaces"></div>
    <div class="footer-content">
      <div class="links">
        <div>&copy; 2020 Netwrix Corporation</div>
        <div>
          <a href="#">Privacy Policy</a> |
          <a href="#">EU Privacy Policy</a> |
          <a href="#">EULA</a> |
          <a href="#" target="_blank">Modern Slavery
            Policy</a>
        </div>
      </div>
      <div class="headquarters">
        <div>
          <b>Corporate Headquarters:</b> 6160 Warren Parkway,
            <br class='visible-xs-inline'> Suite 100 Frisco, TX, US 75034
        </div>
        <div><b>Phone:</b> 1-949-407-5125 | <b>Toll-free:</b> 888-638-9749</div>
      </div>
      <div class="language-selector">
        <span class="language-item active">English</span>
        <a href='#' class="language-item">Français</a>
        <a href='#' class="language-item">Deutsch</a>
        <a href='#' class="language-item">Italiano</a>
      </div>
    </div>
    <div class="footer-right-spaces">
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PageFooter',
  };
</script>

<style lang="less" scoped>
  .footer-flex-container {
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    position: relative;
    z-index: 4;
  }

  .footer-left-spaces, .footer-right-spaces {
    display: flex;
    align-items: stretch;
    flex: 1 0 0;
  }

  .footer-left-spaces {
    min-width: 22px;
  }

  .footer-content {
    display: flex;
    font-size: 12px;
    min-width: 1445px;
    padding: 77px 0 95px;

    b {
      font-weight: 600;
    }

    .links {
      padding-left: 128px;
      flex: 0 0 478px;

      & > div {
        &:nth-child(1) {
          margin-top: 4px;
          margin-bottom: 15px;
        }

        a {
          color: inherit;
          border-bottom: 1px solid #c2c2c2;
          display: inline-block;
          text-decoration: none;
          margin-bottom: 10px;
          padding: 0 0 1px 0;
        }
      }
    }

    .headquarters {
      flex: 0 0 565px;

      & > div {
        &:nth-child(1) {
          margin-top: 4px;
          margin-bottom: 15px;
        }
      }
    }

    .language-selector {
      flex: 0 0 392px;
      padding-top: 4px;

      & > div, & > a {
        display: inline-block;
      }

      .language-item {
        margin: 0 10px;
        border-bottom: 1px solid #5c5c5c;
        cursor: pointer;
        text-decoration: none;

        &.active {
          font-weight: bold;
          border-bottom: none !important;
          cursor: default;
        }
      }
    }
  }
</style>
